import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Common/i18n";
import LoadingModal from "./Common/components/LoadingModal";
import * as Sentry from "@sentry/react";
import { CONSTANTS } from "./config/constants";

const BASE_API_URL = CONSTANTS.BASE_API_URL ?? "https://hire-api.tdcx.app";

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: process.env.SENTRY_DSN_FE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    BASE_API_URL,
    CONSTANTS.APIGEE_BASE_API_URL,
    CONSTANTS.CANDIDATE_CLIENT_URL,
    CONSTANTS.RECRUITER_CLIENT_URL,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.render(
  <Suspense
    fallback={
      <div className="suspense-loading-view">
        <LoadingModal />
      </div>
    }
  >
    <App />
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
